import { observer } from "mobx-react-lite";
import React from "react";
import { ScrollView, Tabs, useTabsContext, View, YGroup } from "tamagui";
import { Body } from "../../ui/Body";
import { Label } from "../../ui/Label";
import { BusinessAdminDevView } from "./BusinessAdminDevView";
import { BusinessCustomerMailsUI } from "./mails/BusinessCustomerMailsUI";
import { BusinessAdminDevCustomersList } from "./ui/BusinessAdminDevCustomersList";

const Tab: React.FC<{
  label: string;
  value: string;
}> = (props) => {
  const tabsContext = useTabsContext();
  const TextComponent = tabsContext.value === props.value ? Label : Body;

  return (
    <Tabs.Tab
      paddingVertical={24}
      paddingHorizontal={32}
      borderRadius={0}
      focusStyle={{ backgroundColor: "$mutedBackground" }}
      value={props.value}
    >
      <TextComponent>{props.label}</TextComponent>
    </Tabs.Tab>
  );
};

export const BusinessAdminDevScreen = observer(() => {
  return (
    <BusinessAdminDevView>
      <Tabs orientation="horizontal" flexDirection="column">
        <YGroup gap={"$medium"}>
          <View position={"sticky" as "static"} zIndex={50} top={58}>
            <ScrollView
              horizontal
              showsHorizontalScrollIndicator={false}
              backgroundColor={"$background"}
            >
              <Tabs.List disablePassBorderRadius>
                <Tab value="customers" label="Customers" />
                <Tab value="mail" label="Mail Machine" />
              </Tabs.List>
            </ScrollView>
          </View>
          <Tabs.Content value="customers">
            <BusinessAdminDevCustomersList />
          </Tabs.Content>
          <Tabs.Content value="mail">
            <BusinessCustomerMailsUI />
          </Tabs.Content>
        </YGroup>
      </Tabs>
    </BusinessAdminDevView>
  );
});
